import * as React from 'react';
import {IVehicleLookup} from '../../data/api/models';
import * as api from '../../data/api/api';
import { WrappedFieldProps } from 'redux-form';
import { Button, Col, FormControl, HelpBlock } from 'react-bootstrap';
import FaSpinner from 'react-icons/fa/spinner';
import FaSearch from 'react-icons/fa/search';

interface IDVLAControlProps extends WrappedFieldProps {
  className?: string;
  onComplete(vehicleLookup: IVehicleLookup): void;
  checkSearch: any;
  duplicateRegistration: boolean;
}

interface IDVLAControlState {
  isSearching: boolean;
  isError: boolean;
  errorText: string;
}

class DVLAControl extends React.Component<IDVLAControlProps, IDVLAControlState> {
  public state = {
    isSearching: false,
    isError: false,
    errorText: '',
  };

  private lookup = () => {
    const { input, onComplete, checkSearch } = this.props;

    this.setState({ isSearching: true });

    api.vehicleLookup(input.value)
      .then((result) => {
        this.setState({
          isSearching: false,
          isError: false,
          errorText: '',
        });
        if (!result.make && !result.model) {
          this.setState({
            isError: true,
            errorText: 'Unable to locate the vehicle, please check the registration and re-enter',
          });
        } else {
          onComplete(result);
        }
      }).catch((err) => {
        this.setState({
          isSearching: false,
        });
        if (err.status === 429) {
          this.setState({
            isError: true,
            errorText: 'Too many search requests, please try again later',
          });
        } else {
          this.setState({
            isError: true,
            errorText: 'Unable to locate the vehicle, please check the registration and re-enter',
          });
        }
      });

    checkSearch();
  }

  public componentWillReceiveProps(nextProps) {
    const { duplicateRegistration } = this.props;
    if (duplicateRegistration !== nextProps.duplicateRegistration) {
      if (nextProps.duplicateRegistration) {
        this.setState({
          isError: true,
          errorText: 'Registration already in use',
        });
      } else {
        this.setState({
          isError: false,
          errorText: '',
        });
      }
    }
  }

  public render() {
    const { input, className, meta, onComplete, checkSearch, ...props } = this.props;
    const { isSearching, isError, errorText } = this.state;

    return (
      <div className={meta.touched && meta.error ? 'has-error ' + className : className}>
        <div>
          <Col sm={7} className="dvla-input">
            <FormControl
              type="text"
              className={meta.dirty ? 'dirty-field' : ''}
              {...input}
              {...props}
            />
          </Col>
          <Col sm={5} className="input-group-btn-container">
            <Button
              bsStyle="primary"
              className="btn-postcode"
              type="button"
              disabled={isSearching || !input.value}
              onClick={this.lookup}
            >
              Search
              {
                isSearching ?
                  <FaSpinner className="fa-spin icon-margin-left" />
                :
                  <FaSearch className="icon-margin-left" />
              }
            </Button>
          </Col>
        </div>

        {meta.touched && meta.error && <HelpBlock>{meta.error}</HelpBlock>}
        {isError && errorText !== '' && <div className="has-error"><HelpBlock>{errorText}</HelpBlock></div>}
      </div>
    );
  }
}

export default DVLAControl;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/components/DVLAControl/index.tsx